module.exports = __webpack_public_path__ + "static/media/sync-refresh.83d0bfd6.svg";